export enum DeliveryType {
  Pickup = 0,
  Delivery = 1,
  Both = 2,
}

export enum OrderStatus {
  Pending = 10, // 未接单未支付，包括支付失败
  WaitingForAcceptance = 20, // 未接单已支付
  Processing = 30, // 已接单已支付（针对线上支付的订单）
  Ready = 31, // 订单 preparing 中
  Delivering = 32, // 订单配送中
  Completed = 40, // 订单已完成
  Rejected = 50, // 商家接单前拒绝接单
  Cancelled = 80, // 订单的 item 全部被 cancel, 或者商家同意退款全部 item
  BadSale = 90, // 此状态暂时先不用理
  CancelRequested = 100, // 订单完成后， 用户将全部item发起申请退款, 判断订单是否正在退款使用 hasPendingApprovalRefund
  CancelRejected = 101, // 用户申请全部 item 的退款，商家拒绝退款 (用户申请部分 item 的退款，商家拒绝之后订单状态依然是 complete)
  Refunding = 102, // 目前没有此情况
  Refunded = 103, // 目前没有此情况
}

export enum PaymentType {
  Offline = 1,
  Online = 2,
}

export enum PaymentStatus {
  Pending = 10,
  Authorized = 20,

  PaidOnline = 30,
  PaidOffline = 31,

  Refunded = 40,

  Voided = 50,
}

export enum OrderItemType {
  Normal = 0,
  Journal = 1,
  PlatformCharge = 2,
  Reversal = 3,
}

export enum PaymentParty {
  Customer,
  Merchant,
  Platform,
}

export enum OrderItemStatus {
  Normal, // 正常的item状态
  Canceled, // item被取消了
  Refunding, // item退款中，Refunding 这个状态在capture时，需要refund的时候才会产生的
  Refunded, // item已退款
  ComplainRequested, // item被申诉请求中
  ComplainRejected, // item的申诉被商家拒绝
}

export enum OrderItemSubType {
  FoodItem,
  DeliveryFeeItem,
  PackagingFeeItem,
  MerchantServiceFeeItem,
  YamimealServiceFeeItem,
  YamimealCommissionItem,
  YamimealProcessingFeeItem,
  Discount,
  Tips,
  UserPoint
}

export enum PaymentMethod {
  CreditCard,
  DebitCard,
  CustomerProfile,
}

export enum ChargeType {
  Capture,
  Authorize,
}

export enum OrderPaymentType {
  Payment = 10,
  Refund = 20,
  Void = 30,
}

export enum PaymentProvider {
  Square,
  AuthorizeNet,
  Stripe,
}

export enum OrderPaymentStatus {
  PendingForCapture = 10,
  Succeed = 20,
  Failed = 30,
}

export enum UserParty {
  Customer,
  Merchant,
  Platform,
}

export enum NavigationMenu {
  Orders,
  Menu,
  Messages,
  Settings,
}

export enum RefundTimes {
  NoRefund,
  Once,
  Twice,
}

export enum OrderTab {
  LiveOrders,
  PreOrder,
  Refunding,
  Incoming,
  Preparing,
  Ready,
  Delivering,
  Completed,
  Rejected,
}

export enum OrderPickupSubtype {
  Normal,
  ParkingLotPickup,
}
